var map = {
	"./ADA.svg": 728,
	"./BCH.svg": 729,
	"./BNB.svg": 730,
	"./BTC.svg": 731,
	"./CHZ.svg": 732,
	"./DASH.svg": 733,
	"./DOGE.svg": 734,
	"./DOT.svg": 735,
	"./ETC.svg": 736,
	"./ETH.svg": 737,
	"./EUR.svg": 738,
	"./GBP.svg": 739,
	"./LINK.svg": 740,
	"./LTC.svg": 741,
	"./MATIC.svg": 742,
	"./MKR.svg": 743,
	"./SHIB.svg": 744,
	"./SOL.svg": 745,
	"./TRX.svg": 746,
	"./UNI.svg": 747,
	"./USD.svg": 748,
	"./USDT.svg": 749,
	"./XLM.svg": 750,
	"./XMR.svg": 751,
	"./XRP.svg": 752,
	"./documents.svg": 753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 727;